import React, { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { MdKeyboardArrowUp } from "react-icons/md";

const Comment = () => {
  const [showReplyBox, setShowReplyBox] = useState(false);
  const [showReplies, setShowReplies] = useState(false);

  const handleReplyClick = () => {
    setShowReplyBox(true);
  };

  const handleCancel = () => {
    setShowReplyBox(false);
  };

  const toggleReplies = () => {
    setShowReplies(!showReplies);
  };

  return (
    <>
      <div className="comment-conatiner p-2">
        <span className="title">Comments</span>

        <div className="message-box mt-3">
          <div className="d-flex align-items-start">
            <div className="reciver-message">
              <span>JD</span>
            </div>

            <div className="ml-3 message-text">
              1. “IPR” shall mean all patents, copyrights, trade secrets,
              trade dress, trademarks, trade names, service marks, industrial
              designs, know-how and any other intellectual property rights
              granted, created or recognised under Applicable Law, whether
              registered or unregistered and whether capable of registration.
              <span className="reply-style ml-2" onClick={handleReplyClick}>
                Reply
              </span>
            </div>
          </div>
        </div>

        {showReplyBox && (
          <div className="message-sendbox mt-3 ml-5">
            <div className="d-flex align-items-start">
              <div className="reciver-message">
                <span>JD</span>
              </div>
              <div className="ml-3 w-100">
                <input
                  className="bottom-border-input"
                  placeholder="Type your message..."
                />
                <div className="action-btn d-flex justify-content-end mt-2">
                  <button className="cancel-btn" onClick={handleCancel}>
                    <span>Cancel</span>
                  </button>
                  <button className="replymessage-btn">
                    <span>Reply</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="reply-count ml-5 mt-2">
          <button className="d-flex align-items-center" onClick={toggleReplies}>
            <span className="repliescount p-1 d-flex align-items-center justify-content-center">
              {showReplies ? (
                <MdKeyboardArrowUp size={15} />
              ) : (
                <IoIosArrowDown className="" size={12} />
              )}
{" "}

              <span className="ml-1">1 Replies</span>
            </span>
          </button>
        </div>

        {showReplies && (
          <div className="ml-5 mt-2 mb-3">
            <div className="d-flex align-items-start">
              <div className="reciver-message">
                <span>AK</span>
              </div>
              <div className="ml-3 message-text">
                “IPR” shall mean all patents, copyrights, trade secrets, trade dress, trademarks, trade names, service marks, industrial designs, know-how and any other intellectual property rights granted, created or recognised under Applicable Law, whether registered or unregistered and whether capable of registration.
                <span className="reply-style ml-2">
                  Reply
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="d-flex justify-content-center mt-2">
        <button className="resubmit-btn d-flex align-items-center">
          <span className="p-1">Amend and Resubmit</span>
        </button>
      </div>

    </>
  );
};

export default Comment;
